import React, { Component, createRef } from 'react';
import classNames from 'classnames';
import { NavButton, TaggisLogo } from '../../atoms';
import { NavItemGroup } from '../../molecules';
/** @typedef {import('../../molecules/NavItemGroup/NavItemGroup').NavItemObj} NavItemObj */

import './styles.css';

const MQ_SMALL_SCREEN = '(max-width: 1076px)';

/**
 * A header with a logo and navigation items.
 *
 * @typedef {Object} Props
 * @prop {Array<NavItemObj>} navItems
 * @prop {Function} [onNavClick]
 * @prop {boolean} [opaque]
 * @prop {boolean} [navOpen]
 * @prop {string} [className]
 *
 * @augments {Component<Props>}
 */
export default class Header extends Component {

	state = {
		isNavOpen: false,
		isSmallScreen: window.matchMedia(MQ_SMALL_SCREEN).matches,
	};

	componentDidMount () {
		this.mql = window.matchMedia(MQ_SMALL_SCREEN);
		this.mql.addListener(this.handleMediaChange);
	}

	componentDidUpdate (prevProps, prevState) {
		if (this.state.isNavOpen !== prevState.isNavOpen) {
			if (this.state.isNavOpen) {
				this.toggleBodyOverflow(false);
			} else {
				this.toggleBodyOverflow(true);
			}
		}
	}

	componentWillUnmount () {
		this.mql.removeListener(this.handleMediaChange);
		this.toggleBodyOverflow(true);
	}

	ref = createRef();

	handleAnchorClick = ({ target }) => {
		if (target.tagName === 'A') this.setState({ isNavOpen: false });
	}

	handleMediaChange = ({ matches }) =>
		this.setState(({ isNavOpen }) => ({
			isNavOpen: matches ? isNavOpen : false,
			isSmallScreen: !!matches,
		}));

	handleNavClick = () =>
		this.setState(({ isNavOpen }) => ({
			isNavOpen: !isNavOpen,
		}));

	genClassName = (props, state) =>
		classNames('Header', props.className, {
			backdrop: props.opaque || state.isNavOpen,
			backdropFull: state.isNavOpen,
		});

	genDrawClassName = (state) =>
		classNames('Header-mobileDraw', {
			visible: state.isNavOpen,
		});

	toggleBodyOverflow = (shouldShow) => {
		document.body.style.overflowY = shouldShow ? '' : 'hidden';
	}

	render () {
		const { navItems = [], opaque } = this.props;
		const { isNavOpen, isSmallScreen } = this.state;

		return (
			<header
				className={this.genClassName(this.props, this.state)}
				onClick={this.handleAnchorClick}
				ref={this.ref}
			>
				<div className='Header-wrapper'>
					<TaggisLogo className='Header-logo' white={!opaque && !isNavOpen} />
					{isSmallScreen
						? <NavButton onClick={this.handleNavClick} open={isNavOpen} />
						: <NavItemGroup className='Header-navItems' navItems={navItems} />
					}
				</div>
				{isSmallScreen
					? <div className={this.genDrawClassName(this.state)}>
						<NavItemGroup className='Header-navItems' navItems={navItems} />
					</div>
					: null
				}

			</header>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/organisms/Header/Header.js